import { useTranslation } from "../../i18n/useTranslation";
import { getLinkToContactForm } from "./fixcenter-support.service";
import styles from "./FixcenterSupportSeeDetail.module.scss";
import { FixcenterSupportType } from './fixcenter-support-type.enum';
import { Link } from 'react-router-dom';
import { getCmsLinkToServices } from '../../containers/cms-container/services/cms-navigation.service';
import { redirectToCalaculationProgramDemo } from '../../services/calculation-program.service';
import classNames from 'classnames';
import globalStyles from '../../global-styles.module.scss';
import { htmlId } from './FixcenterSupportSeeDetail.service';
import { User } from '../client-panel/components/my-account-info/models/user.model';
import { useBetween } from 'use-between';
import { UserDetailsUseBetween } from '../../shared/use-between/user-details-use-between';

export interface IFixcenterSupportSeeDetail {
    type: FixcenterSupportType;
}

const FixcenterSupportSeeDetail: React.FC<IFixcenterSupportSeeDetail> = ({type}) => {
    const { t } = useTranslation('translation');
    const { userDetails } = useBetween(UserDetailsUseBetween);

       return (
           <>
               {type === FixcenterSupportType.OUR_SALES && (
                    <Link 
                        to={getLinkToContactForm()} 
                        className={styles.fixcenter_support_see_detail_content} 
                        style={{ textDecoration: 'none'}}>
                        <span className={styles.text}>
                            {t('SEE_DETAILS')} &#187;
                        </span>
                    </Link>
               )}
                {type === FixcenterSupportType.OUR_SUPPORT && (
                    <Link 
                        to={getCmsLinkToServices()} 
                        className={styles.fixcenter_support_see_detail_content} 
                        style={{ textDecoration: 'none'}}>
                        <span className={styles.text}>
                            {t('SEE_DETAILS')} &#187;
                        </span>
                    </Link>
               )}
               {type === FixcenterSupportType.CALCULATION_PROGRAM && (
                    <button 
                        onClick={() => {
                            redirectToCalaculationProgramDemo(userDetails as User) 
                        }}
                        id = {`${htmlId}-calculation-program-btn`}
                        className={classNames(globalStyles.default_button_style, globalStyles.float_left_item, styles.fixcenter_support_see_detail_content)}
                        style={{ textDecoration: 'none'}}>
                        <span className={styles.text}>
                            {t('SEE_DETAILS')} &#187;
                        </span>
                    </button>
               )}
           </>
       );
};

export default FixcenterSupportSeeDetail;